var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-text-input-password"},[_c('input',{staticClass:"base-text-input-password-class",attrs:{"type":"password","name":"password","maxlength":"100","placeholder":_vm.$t('common.placeholderPassword'),"autocomplete":_vm.newFlg ? 'new-password' : 'on'},domProps:{"value":_vm.value},on:{"input":_vm.inputText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }